let scrollElement = document;

let leftClouds = [
  $('.clouds-left-3'),
  $('.clouds-left-2'),
  $('.clouds-left-1')
];

let rightClouds = [
  $('.clouds-right-3'),
  $('.clouds-right-2'),
  $('.clouds-right-1')
];

let boat = $('.boat');
let tick = false;

window.mobile = false;
window.lastScroll = 0;
window.isMobile = /Mobi/.test(navigator.userAgent);

function resetContactForm() {
  $('.contact-form').removeClass('animate-in');
  $('.contact-form').addClass('animate-out');
  $('.contact-close').css('display', 'none');

  setTimeout(() => {
    $(document.body).removeClass('no-scroll');
    $('.contact-form').removeClass('animate-out');
    $('.main-contact-content').removeClass('contactFadeAway');
    $('.main-contact-content').css({
      display: 'flex'
    });
    $('.contact-res').css({
      visibility: 'hidden',
      opacity: 0,
      position: 'absolute'
    });
    $('.contact-res').find('h1').text('Sending...');
    $('.contact-close').css('display', 'block');
  }, 400);
}

$(document).ready(() => {
  if (!window.isMobile) {
    $(scrollElement).on('scroll', () => requestTick());
    $(window).on('resize', () => requestTick());
  } else {
    leftClouds.forEach(cloud => cloud.remove());
    rightClouds.forEach(cloud => cloud.remove());
    $('.lights').remove();
    $('header').css({
      'overflow': 'hidden'
    });
  }

  requestAnimationFrame(handleAnimations);

  $(document).on('click', '.subthumbnailimg', e => {
    let $bigImage = $('<div class="big-image">');
    $bigImage.css({
      'background-image': `url(${e.target.src})`
    });
    let $closeButton = $('<button class="big-close-button">');
    $closeButton.text('X');
    $closeButton.on('click', () => {
      $bigImage.remove();
      $(document.body).removeClass('no-scroll');
    });
    $bigImage.append($closeButton);
    $(document.body).append($bigImage);
    $(document.body).addClass('no-scroll');
  });

  $(document).on('click', '#contact-form', e => {
    e.preventDefault();
    $(document.body).addClass('no-scroll');
    $('.contact-form').addClass('animate-in');
  });

  $('#contact-form-element').submit(e => {
    e.preventDefault();

    $('.contact-close').css('display', 'none');
    
    $('.main-contact-content').addClass('contactFadeAway');
    setTimeout(() => {
      $('.main-contact-content').removeClass('contactFadeAway');
      $('.main-contact-content').css({
        display: 'none'
      });
      $('.contact-res').css({
        visibility: 'visible',
        opacity: 1,
        position: 'static'
      });
      $.ajax({
        url: 'email.php',
        type: 'post',
        data: $('#contact-form-element').serialize(),
        success: e => {
          if (e === 'success') {
            $('.contact-res').find('h1').text('Success!');
          } else {
            $('.contact-res').find('h1').text('Please try again.');
          }

          setTimeout(() => {
            resetContactForm();
          }, 1000);
        }
      });
    }, 400);
  });

  $(document).on('click', '.contact-close', () => {
    resetContactForm();
  });
});

$(window).on('load', () => {
  $('.loader').css('opacity', '0');
  $(document.body).removeClass('no-scroll');

  setTimeout(() => {
    $('.loader').remove();
  }, 500);
});

function requestTick() {
  if (!tick) {
    requestAnimationFrame(handleAnimations);    
  }
  tick = true;
}

function handleAnimations() {
  tick = false;

  let scroll = $(scrollElement).scrollTop();

  if (window.lastScroll !== 0 && window.lastScroll === scroll) {
    return;
  } else {
    window.lastScroll = scroll;
  }

  if (window.mobile) {
    return;
  }

  if (window.isMobile) {
    scroll = 400;
    window.mobile = true;
    boat.css({
      'transition': 'none'
    });
  }
 
  let positions = [
    scroll,
    scroll * 2,
    scroll * 3
  ];

  leftClouds.forEach((cloud, i) => {
    let offset = cloud.data('offset');

    cloud.css({
      transform: `translateX(calc(-50% - ${positions[i] + offset}px))`
    });
  });

  rightClouds.forEach((cloud, i) => {
    let offset = cloud.data('offset');

    cloud.css({
      transform: `translateX(calc(-50% + ${positions[i] + offset}px))`
    });
  });

  let boatPosition = scroll * -1;

  boat.css({
    transform: `translateX(calc(-50% - ${boatPosition + 400}px))`
  });
}
